import { EmptyState, FlexColumn, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { useStyles } from '../../../hooks/useStyles';
import {
  loadingUsersState,
  selectedUserIdState,
  userIdsState,
  usersPageState,
  usersState,
} from '../../../storage/users';
import { User } from '../../../types/user';
import { VirtualizedPaginatedList } from '../../shared/VirtualizedPaginatedList';
import UserItem from './UserItem';

export function UserList() {
  const { css } = useStyles();
  const userIds = useRecoilValue(userIdsState);
  const setSelectedUserId = useSetRecoilState(selectedUserIdState);
  const resetSelectedUserId = useResetRecoilState(selectedUserIdState);
  const loadingUsers = useRecoilValue(loadingUsersState);
  const paginatedUsers = useRecoilValue(usersState);
  const setUsersPage = useSetRecoilState(usersPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedUserId();
    };
  });

  const onNewUser = () => {
    setSelectedUserId('');
  };

  return (
    <FlexColumn classNames={css({ height: '100%' })}>
      {(!userIds || !userIds.length) && !loadingUsers && <EmptyState title="No tienes ningun usuario" />}
      {(!userIds || !userIds.length) && loadingUsers && <Loading />}
      <VirtualizedPaginatedList<User>
        ids={userIds}
        loading={loadingUsers}
        onNextPage={setUsersPage}
        paginatedResponse={paginatedUsers}
        itemComponent={UserItem}
        itemSize={SMALL_LIST_ITEM_HEIGHT}
      />
      <StyledButton
        size="compact"
        shape="square"
        onClick={onNewUser}
        startEnhancer={<MaterialIcon name={'add'} />}
        kind="tertiary"
      >
        Nuevo usuario
      </StyledButton>
    </FlexColumn>
  );
}
